import Vue from 'vue';
import { VClosePopover, VPopover, VTooltip } from 'v-tooltip';
// Disable on mobile
// @ts-ignore
VTooltip.enabled = window.innerWidth > 768;
Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);
